import { render, staticRenderFns } from "./SkeletonLoader_1.vue?vue&type=template&id=1f7fe57c&scoped=true"
import script from "./SkeletonLoader_1.vue?vue&type=script&lang=js"
export * from "./SkeletonLoader_1.vue?vue&type=script&lang=js"
import style0 from "./SkeletonLoader_1.vue?vue&type=style&index=0&id=1f7fe57c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7fe57c",
  null
  
)

export default component.exports